"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var rIC = window.requestIdleCallback || window.setTimeout;
exports.default = rIC;


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/rIC.js
// module id = 2295
// module chunks = 0